import { useDispatch } from "react-redux";
import { setTextToSearch } from "./cardTextSlice";
import "./Card.css";
// import { hide } from "components/Home/homeVisibilitySlice";
// import { hooks } from 'botframework-webchat-component';

// const { useSendBoxValue, useSubmitSendBox,  } = hooks;

interface CardImgProps{
  id:    number;
  image: string;
}

interface CardProps {
  id:       number;
  category: string;
  prompt:   string;
  content:  string;
}

const cardsImages: CardImgProps[] = [
  {
    id: 0,
    image: "Money.png",
  },
  {
    id: 1,
    image: "Path.png",
  },
  {
    id: 2,
    image: "Graphic.png",
  },
  {
    id: 3,
    image: "Summary.png",
  },
];

export function Card(props: { card: CardProps }) {
  let dispatch = useDispatch();
  // const [sendBoxValue, setSendBoxValue] = useSendBoxValue();


  const handleClick = (text: string) => {
    dispatch(setTextToSearch(text))
    // setSendBoxValue(text)
    
    //dispatch(hide());
  }

  const getCardImgName = (cardId: number) => {
    return cardsImages.find(i => i.id === cardId)?.image
  }

  return (
    <>
      <div
        className="card"
        onClick={() => handleClick(props.card.content)}
      >
        <div className="card__content">
          <img src={`static/images/icons/${getCardImgName(props.card.id)}`} />
          <span>{props.card.content}</span>
        </div>
      </div>
    </>
  );
}
